import { gtmDataLayerPush, clearEcommerceObject } from "./gtm";
import {
  IEcommerce,
  IEcommerceItem,
  IEnquiryConversion,
  IEnquiryForm,
  ICorporateEnquiryForm,
  ISearchFilterInteraction,
} from "./types";
import { generateEventId } from "./helpers";

// page_view
export const pageViewEvent = (data: {
  language: string;
  pageCategory: string;
}) => {
  gtmDataLayerPush({
    event: "page_view",
    event_id_page_view: generateEventId(),
    ...data,
  });
};

// select_item
export const selectItemEvent = (
  ecommerce: IEcommerce & {
    item_list_name: string;
  }
) => {
  clearEcommerceObject();
  gtmDataLayerPush({
    event: "select_item",
    ecommerce,
  });
};

// view_item
export const viewItemEvent = (ecommerce: IEcommerce) => {
  clearEcommerceObject();
  gtmDataLayerPush({
    event: "view_item",
    event_id_view_item: generateEventId(),
    ecommerce,
  });
};

// add_to_wishlist
export const addToWishlistEvent = (ecommerce: IEcommerce) => {
  clearEcommerceObject();
  gtmDataLayerPush({
    event: "add_to_wishlist",
    event_id_add_to_wishlist: generateEventId(),
    ecommerce,
  });
};

// view_item_list
export const viewItemListEvent = (
  ecommerce: IEcommerce & {
    item_list_name: string;
  }
) => {
  clearEcommerceObject();
  gtmDataLayerPush({
    event: "view_item_list",
    event_id_view_item_list: generateEventId(),
    ecommerce,
  });
};

// new_phone_button_click
export const newPhoneButtonClickEvent = (
  data:
    | (Omit<IEcommerceItem, "index"> & IEnquiryConversion)
    | IEnquiryConversion
) => {
  gtmDataLayerPush({
    event: "new_phone_button_click",
    event_id_new_phone_button_click: generateEventId(),
    ...data,
  });
};

// parking_phone_number_button_click
export const parkingPhoneNumberButtonClickEvent = (
  data:
    | (Omit<IEcommerceItem, "index"> & IEnquiryConversion)
    | IEnquiryConversion
) => {
  gtmDataLayerPush({
    event: "parking_phone_number_button_click",
    event_id_parking_phone_number_button_click: generateEventId(),
    ...data,
  });
};

// new_enquiry_form_button_click
export const newEnquiryFormButtonClickEvent = (
  data:
    | (Omit<IEcommerceItem, "index"> & { enquiry_type: string })
    | { enquiry_type: string }
) => {
  gtmDataLayerPush({
    event: "new_enquiry_form_button_click",
    event_id_new_enquiry_form_button_click: generateEventId(),
    ...data,
  });
};

// new_appointment_button_click
export const newAppointmentButtonClickEvent = (
  data: Omit<IEcommerceItem, "index"> & { enquiry_type: string }
) => {
  gtmDataLayerPush({
    event: "new_appointment_button_click",
    event_id_new_appointment_button_click: generateEventId(),
    ...data,
  });
};

// new_appointment_submission
export const newAppointmentSubmissionEvent = (
  data: Omit<IEcommerceItem, "index"> & IEnquiryForm
) => {
  gtmDataLayerPush({
    event: "new_appointment_submission",
    event_id_new_appointment_submission: generateEventId(),
    ...data,
  });
};

// new_enquiry_form_submission
export const newEnquiryFormSubmissionEvent = (
  data:
    | (Omit<IEcommerceItem, "index"> & IEnquiryForm)
    | IEnquiryForm
    | ICorporateEnquiryForm
) => {
  gtmDataLayerPush({
    event: "new_enquiry_form_submission",
    event_id_new_enquiry_form_submission: generateEventId(),
    ...data,
  });
};

// parking_enquiry_form_submission
export const parkingEnquiryFormSubmissionEvent = (
  data: (Omit<IEcommerceItem, "index"> & IEnquiryForm) | IEnquiryForm
) => {
  gtmDataLayerPush({
    event: "parking_enquiry_form_submission",
    event_id_parking_enquiry_form_submission: generateEventId(),
    ...data,
  });
};

// search
export const searchEvent = (data: {
  search_category: string;
  selected_province?: string;
  selected_district?: string;
  selected_city?: string;
  selected_railway_line?: string;
  selected_station?: string;
  selected_term?: string;
}) => {
  gtmDataLayerPush({
    event: "search",
    ...data,
  });
};

// search_filter_interaction_roomsize
export const searchFilterInteractionRoomsizeEvent = (
  data: ISearchFilterInteraction & {
    selected_roomsize: string;
  }
) => {
  gtmDataLayerPush({
    event: "search_filter_interaction_roomsize",
    ...data,
  });
};

// search_filter_interaction_roomtype
export const searchFilterInteractionRoomtypeEvent = (
  data: ISearchFilterInteraction & {
    selected_roomtype: string;
  }
) => {
  gtmDataLayerPush({
    event: "search_filter_interaction_roomtype",
    ...data,
  });
};

// search_filter_interaction_rent
export const searchFilterInteractionRentEvent = (
  data: ISearchFilterInteraction & {
    selected_rent: string;
  }
) => {
  gtmDataLayerPush({
    event: "search_filter_interaction_rent",
    ...data,
  });
};

// search_filter_interaction_options
export const searchFilterInteractionOptionsEvent = (
  data: ISearchFilterInteraction & {
    selected_option: string;
  }
) => {
  gtmDataLayerPush({
    event: "search_filter_interaction_options",
    ...data,
  });
};

// faq_interaction
export const faqInteractionEvent = (data: {
  enquiry_type: string;
  faq_title: string;
}) => {
  gtmDataLayerPush({
    event: "faq_interaction",
    event_id_faq_interaction: generateEventId(),
    ...data,
  });
};
